import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class EventsService {
    private activateDebugModeSubject = new Subject<void>();

    publishActivateDebugMode() {
        this.activateDebugModeSubject.next();
    }

    getActivateDebugModeSubjectObservable(): Observable<void> {
        return this.activateDebugModeSubject;
    }
}